import { always, apiFetch } from 'utils'

export function getAboutData () {
  return apiFetch(`/about/`)
  .catch(always([]))
}



// WEBPACK FOOTER //
// ./resources/assets/js/transport/about.js